enum DisplayNames {
  Select = 'Select'
}

export default DisplayNames;
